import { render, staticRenderFns } from "./FormColorSetting.vue?vue&type=template&id=467665e7&"
import script from "./FormColorSetting.vue?vue&type=script&lang=js&"
export * from "./FormColorSetting.vue?vue&type=script&lang=js&"
import style0 from "./FormColorSetting.vue?vue&type=style&index=0&id=467665e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports